// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleOnClick() {

    this.closePipCodeRequestModal();

}

const PipCodeRequestModalHeader = props =>
    <header className='pip-code-request-modal-header'>
        <FormattedMessage
            id={`${props.pipCodeRequestModalAction}_PIP_CODE_REQUEST`}
        />
        <span
            className='close-modal-icon'
            onClick={props::handleOnClick}
        />
    </header>;

PipCodeRequestModalHeader.displayName = 'PipCodeRequestModalHeader';
PipCodeRequestModalHeader.propTypes = {
    closePipCodeRequestModal: PropTypes.func.isRequired,
    pipCodeRequestModalAction: PropTypes.string.isRequired
};

export default PipCodeRequestModalHeader;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/pip-code-requests/pip-code-request-modal-header.js